import React from 'react';
import { useLocation } from 'react-router-dom';

import { ROUTES } from 'consts';
import { useParamValues } from 'hooks/url.hook';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

import { ZonesTab, GetTabValueProps } from './zones-tab';

export const ZonesTabInBuilding = () => {
  const { buildingId: building } = useParamValues(['buildingId']);
  const location = useLocation();
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const buildingId = building ? Number(building) : null;

  const getTabValue = ({ status }: GetTabValueProps) => {
    switch (status) {
      case 'active': {
        return ROUTES.ZONES_ACTIVE;
      }

      case 'inactive': {
        return ROUTES.ZONES_INACTIVE;
      }

      default: {
        return '';
      }
    }
  };

  const getCurrentTabValue = () => {
    return location.pathname.replace(building, ':buildingId').replace(`/${orgSlug}/${ROUTES.BUILDING_DETAILS}/`, '');
  };

  return <ZonesTab buildingId={buildingId} getTabValue={getTabValue} getCurrentTabValue={getCurrentTabValue} />;
};
